import { useEffect } from 'react'

export function useVisualViewportHeight() {
  useEffect(() => {
    const updateVh = () => {
      const vh = window.visualViewport?.height ?? window.innerHeight
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }

    updateVh()

    const vv = window.visualViewport
    vv?.addEventListener('resize', updateVh)
    window.addEventListener('resize', updateVh)

    return () => {
      vv?.removeEventListener('resize', updateVh)
      window.removeEventListener('resize', updateVh)
    }
  }, [])
}
